// Client-side gzip compression for upload payloads.
//
// Why: the production ingress (nginx) caps multipart uploads at ~100 MB. Our
// master/ETS/pricelist CSVs for 370k+ products can easily exceed that. Text
// data compresses 8-12× with gzip, so a 200 MB CSV becomes ~20 MB and goes
// through fine.
//
// How: we use the browser-native CompressionStream API (supported in Chrome,
// Edge, Firefox, Safari 17+). The compressed Blob is sent as a File with the
// same name + ".gz" suffix, and the backend detects either the suffix or the
// gzip magic bytes (1f 8b) and decompresses on the fly.
//
// Threshold: only compress files >2 MB so tiny uploads (a quick test CSV)
// stay un-compressed and fast.

const COMPRESS_THRESHOLD = 2 * 1024 * 1024; // 2 MB

export async function maybeGzipFile(file) {
  if (!file) return file;
  // Skip already-compressed formats — xlsx is a zip container, gzipping it
  // again is a waste (and openpyxl needs the original bytes).
  const lower = (file.name || "").toLowerCase();
  if (/\.(xlsx|xlsm|xltx|xltm|zip|gz|gzip)$/.test(lower)) return file;
  if (file.size < COMPRESS_THRESHOLD) return file;
  if (typeof CompressionStream === "undefined") return file; // very old browser

  try {
    const stream = file.stream().pipeThrough(new CompressionStream("gzip"));
    const blob = await new Response(stream).blob();
    return new File([blob], `${file.name}.gz`, { type: "application/gzip" });
  } catch {
    // If anything goes wrong (e.g., browser quirk), fall back to raw upload.
    return file;
  }
}
